var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"auto p-0"}},[_c('div',[_c('b',[_vm._v("Upman")])]),_c('div',[_c('router-link',{attrs:{"to":{ name: 'About'}}},[_vm._v("About")])],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }